import { EventBus, ViewModel } from '@descomplica/microfrontend-core';
import { action, computed, makeObservable } from 'mobx';

import { ExercisesModel } from '@/presentation/models/exercises.model';
import { StudentClassesModel } from '@/presentation/models/student-classes.model';
import { StudyPlanModel } from '@/presentation/models/studyPlan.model';
import { UserModel } from '@/presentation/models/user.model';

@ViewModel()
export class DrawerMenuViewModel {
  constructor(
    private readonly eventBus: EventBus,
    private readonly userModel: UserModel,
    private readonly studyPlanModel: StudyPlanModel,
    private readonly exercisesModel: ExercisesModel,
    private readonly studentClassesModel: StudentClassesModel,
  ) {
    makeObservable(this);
  }

  @computed
  get shouldShowPaywall() {
    return this.studentClassesModel.shouldShowPaywall;
  }

  @computed
  get shouldShowStudyPlanTab() {
    return this.studyPlanModel.shouldShowStudyPlanTab;
  }

  @computed
  get shouldShowPracticeTab() {
    return this.shouldShowEssayMenu || this.shouldShowExerciseMenu;
  }

  @computed
  get shouldShowExerciseMenu() {
    return (
      this.userModel.user.permissions.canViewAdmin || this.exercisesModel.shouldShowExerciseTab
    );
  }

  @computed
  get shouldShowEssayMenu() {
    return (
      this.userModel.user.permissions.canViewAdmin || this.userModel.user.permissions.canViewEssay
    );
  }

  @action
  clearAccount() {
    return this.userModel.clearAccount();
  }

  @computed
  get user() {
    return this.userModel.user;
  }
}
